import React, { Component } from 'react';

class SocialMediaIcon extends Component {
    render() {
        return (
            <a href={this.props.url} rel="noreferrer">
                <i className={this.props.icon}/>
            </a>
        );
    }
}

export default SocialMediaIcon;